import "../styles/App.css";
import "../styles/pages/About.css";

import CustomText from "../components/Text";
import Header from "../components/Header";

function About() {
  return (
    <div id="about" className="section" style={{backgroundColor: "#FFFFFF"}}>
      <div className="aboutWrapper">
        <Header content="Quem Somos" />
        <CustomText
          type="desc"
          content="A MNR - Clínica de Psicologia é um espaço de Psicologia Clínica e da Saúde, localizado em Lisboa, numa área de fácil acesso, que fornece serviços de diagnóstico e tratamento psicológico individual, grupos, famílias e casal, nomeadamente Consulta de Avaliação Psicológica, Acompanhamento Psicológico e Psicoterapia de apoio individual. Desenvolve ainda projetos de psicoeducação de pais, baseados no modelo Reflective Parenting, desenvolvido pelo Anna Freud Center - Londres."
        />
      </div>
    </div>
  );
}

export default About;
